(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-item"] && !Shopify.designMode) return;
  try {
    if (!window.seedAccordionBound) {
    window.seedAccordionBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.seed-accordion-trigger');
      if (!trigger) return;

      const item = trigger.closest('[data-accordion-item]');
      const panel = item.querySelector('.seed-accordion-panel');
      const open = trigger.getAttribute('aria-expanded') !== 'true';

      trigger.setAttribute('aria-expanded', String(open));
      item.classList.toggle('seed-accordion-item--open', open);
      panel.classList.toggle('seed-accordion-panel--hidden', !open);
      item.querySelector('.seed-accordion-icon').textContent = open ? '−' : '+';
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    if (!window.seedFiltersBound) {
    window.seedFiltersBound = true;

    const paintSlider = (slider) => {
      const min = slider.querySelector('[data-price-min]');
      const max = slider.querySelector('[data-price-max]');
      const low = Number(min.value);
      const high = Number(max.value);
      const span = Number(max.max) - Number(min.min) || 1;
      const fill = slider.querySelector('[data-price-fill]');
      fill.style.setProperty('--fill-left', `${((low - Number(min.min)) / span) * 100}%`);
      fill.style.setProperty('--fill-right', `${100 - ((high - Number(min.min)) / span) * 100}%`);
      min.style.setProperty('--thumb-z', low >= high - 10 ? '5' : '3');
      slider.querySelector('[data-price-min-label]').textContent = `${slider.dataset.currency}${low}`;
      slider.querySelector('[data-price-max-label]').textContent = `${slider.dataset.currency}${high}`;
    };

    const initSliders = (root) => root.querySelectorAll('[data-price-slider]').forEach(paintSlider);

    document.addEventListener('input', (event) => {
      const slider = event.target.closest('[data-price-slider]');
      if (!slider) return;
      const min = slider.querySelector('[data-price-min]');
      const max = slider.querySelector('[data-price-max]');
      if (event.target === min) min.value = Math.min(Number(min.value), Number(max.value) - 1);
      if (event.target === max) max.value = Math.max(Number(max.value), Number(min.value) + 1);
      paintSlider(slider);
    });

    // Builds the destination from the form's own fields only, so nothing else in the current
    // query string (q, variant, pr_*, direction, page, legacy filter={...}) is carried along.
    const submitFilters = (form) => {
      const url = new URL(form.getAttribute('action'), window.location.origin);
      new FormData(form).forEach((value, key) => url.searchParams.append(key, value));
      window.location.assign(url.toString());
    };

    const syncPriceFields = (slider) => {
      const min = slider.querySelector('[data-price-min]');
      const max = slider.querySelector('[data-price-max]');
      const minField = slider.querySelector('[data-price-min-field]');
      const maxField = slider.querySelector('[data-price-max-field]');
      minField.value = min.value;
      maxField.value = max.value;
      minField.disabled = Number(min.value) <= Number(min.min);
      maxField.disabled = Number(max.value) >= Number(max.max);
    };

    document.addEventListener('change', (event) => {
      const form = event.target.closest('[data-filter-form]');
      if (!form) return;
      const slider = event.target.closest('[data-price-slider]');
      if (slider) syncPriceFields(slider);
      submitFilters(form);
    });

    // Active-filter pills (sections/main-collection.liquid) are buttons: they clear the matching
    // field in the filter form and resubmit it, instead of linking to a url_to_remove URL.
    document.addEventListener('click', (event) => {
      const pill = event.target.closest('[data-remove-filter], [data-remove-price]');
      if (!pill) return;
      const form = document.querySelector('[data-filter-form]');
      if (!form) return;
      if (pill.hasAttribute('data-remove-price')) {
        form.querySelectorAll('[data-price-min-field], [data-price-max-field]').forEach((field) => {
          field.disabled = true;
        });
      } else {
        form.querySelectorAll('input[type="checkbox"]').forEach((box) => {
          if (box.name === pill.dataset.removeFilter && box.value === pill.dataset.removeValue) box.checked = false;
        });
      }
      submitFilters(form);
    });

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-filter-group] > .seed-filter-group-toggle');
      if (!toggle) return;
      const body = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.querySelector('.seed-filter-group-chevron').classList.toggle('seed-filter-group-chevron--open', open);
      if (body) body.hidden = !open;
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSliders(document));
    } else {
      initSliders(document);
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["listing-load-more"] && !Shopify.designMode) return;
  try {
    if (!window.seedLoadMoreBound) {
    window.seedLoadMoreBound = true;

    document.addEventListener('click', async (event) => {
      const link = event.target.closest('[data-load-more]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;

      const gridId = link.dataset.loadMore;
      const grid = document.getElementById(gridId);
      if (!grid || link.getAttribute('aria-busy') === 'true') return;

      event.preventDefault();
      const nextUrl = link.dataset.nextUrl || link.href;
      const label = link.textContent;
      link.setAttribute('aria-busy', 'true');
      link.textContent = link.dataset.loadingLabel;

      try {
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', link.dataset.sectionId);
        const response = await fetch(url.toString());
        if (!response.ok) throw new Error('load more failed');

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = doc.getElementById(gridId);
        if (!nextGrid) throw new Error('grid missing from response');

        const firstNew = nextGrid.firstElementChild;
        grid.append(...nextGrid.children);

        const wrap = link.closest('[data-load-more-wrap]');
        const nextWrap = doc.querySelector(`[data-load-more-wrap="${gridId}"]`);
        if (nextWrap) {
          wrap.replaceWith(nextWrap);
        } else {
          wrap.remove();
        }

        const focusTarget = firstNew && firstNew.querySelector('a[href]');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      } catch (error) {
        const fallback = new URL(nextUrl, window.location.origin);
        fallback.searchParams.delete('section_id');
        window.location.href = fallback.toString();
      } finally {
        link.removeAttribute('aria-busy');
        link.textContent = label;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-exclusive-accordion"] && !Shopify.designMode) return;
  try {
    if (!window.seedExclusiveAccordionBound) {
    window.seedExclusiveAccordionBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-exclusive-accordion] .seed-accordion-trigger');
      if (!trigger) return;

      const list = trigger.closest('[data-exclusive-accordion]');
      const current = trigger.closest('[data-accordion-item]');

      list.querySelectorAll('[data-accordion-item]').forEach((item) => {
        if (item === current) return;
        const otherTrigger = item.querySelector('.seed-accordion-trigger');
        otherTrigger.setAttribute('aria-expanded', 'false');
        item.classList.remove('seed-accordion-item--open');
        item.querySelector('.seed-accordion-panel').classList.add('seed-accordion-panel--hidden');
        item.querySelector('.seed-accordion-icon').textContent = '+';
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-bought-together"] && !Shopify.designMode) return;
  try {
    (() => {
    const requests = new Map();
    let quickAddForm;
    let quickAddId;

    // Fills every strip that has not been filled yet. The buy box is re-rendered
    // when the shopper picks another variant, so this runs again after each swap.
    const hydrate = () => {
      document.querySelectorAll('[data-bought-together]:not([data-bt-ready])').forEach((box) => {
        box.dataset.btReady = '';
        const url = box.dataset.url;
        if (!requests.has(url)) {
          requests.set(
            url,
            fetch(url)
              .then((response) => (response.ok ? response.text() : ''))
              .catch(() => ''),
          );
        }
        requests.get(url).then((html) => {
          if (!html || !box.isConnected) return;
          const cards = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelectorAll('[data-bt-source] [data-bt-card]');
          if (cards.length === 0) return;
          box.querySelector('[data-bt-list]').replaceChildren(...cards);
          box.hidden = false;
        });
      });
    };

    // "+" goes through a hidden [data-add-to-cart] form outside the product form,
    // so assets/seed-cart.js adds the item and opens the cart drawer as usual.
    document.addEventListener('click', (event) => {
      const button = event.target.closest ? event.target.closest('[data-bt-add][data-variant-id]') : null;
      if (!button) return;
      const box = button.closest('[data-bought-together]');
      if (!box) return;
      event.preventDefault();
      if (button.getAttribute('aria-busy') === 'true') return;

      if (!quickAddForm) {
        quickAddForm = document.createElement('form');
        quickAddForm.method = 'post';
        quickAddForm.action = box.dataset.cartAddUrl;
        quickAddForm.hidden = true;
        quickAddForm.setAttribute('data-add-to-cart', '');
        quickAddId = document.createElement('input');
        quickAddId.type = 'hidden';
        quickAddId.name = 'id';
        const quantity = document.createElement('input');
        quantity.type = 'hidden';
        quantity.name = 'quantity';
        quantity.value = '1';
        quickAddForm.append(quickAddId, quantity);
        document.body.append(quickAddForm);
      }
      quickAddId.value = button.dataset.variantId;

      const release = () => button.removeAttribute('aria-busy');
      button.setAttribute('aria-busy', 'true');
      document.addEventListener('cart:updated', release, { once: true });
      setTimeout(release, 6000);

      if (typeof quickAddForm.requestSubmit === 'function') quickAddForm.requestSubmit();
      else quickAddForm.submit();
    });

    hydrate();
    const productRoot = document.querySelector('[data-product-section]');
    if (productRoot) new MutationObserver(hydrate).observe(productRoot, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
